import script from "./cadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./cadastro.vue?vue&type=script&setup=true&lang=js"

import "./cadastro.vue?vue&type=style&index=0&id=08f44fb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f44fb8"]])

export default __exports__